import React from 'react';

import FormList from './FormList';
import TwoColumn from '../../components/TwoColumn';
import DynamicForm from './DynamicForm';

export default function Form() {
  const [currentForm, setCurrentForm] = React.useState('');

  const handleFormSelect = (id: string) => {
    setCurrentForm(id);
  };

  const handleBack = () => {
    setCurrentForm('');
  };

  return (
    <TwoColumn right={currentForm !== ''}>
      <TwoColumn.Left>
        <FormList onSelect={handleFormSelect} />
      </TwoColumn.Left>
      <TwoColumn.Right>
        <DynamicForm id={currentForm} onBack={handleBack} />
      </TwoColumn.Right>
    </TwoColumn>
  );
}
